// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3s8YV","productName":"Table_productName__1hSPJ"};